module.exports = __webpack_public_path__ + "media/images/WFC_Landscape_White-63a01df02bd4cbda0aa902e5a0242641.png";